import React, { useEffect } from "react";
import Home from "./Home";

export default function Contact() {
  useEffect(() => {
    const el = document.getElementById("contact");
    if (el) {
      // Wait a bit for Home to render fully
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, []);

  return <Home />;
}
